import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";
import { refreshTranslations } from "./refresh";
import { formTranslations } from "./formPlus";

const LanguageContext = createContext(null);

const lookup = (lang, path) => path.startsWith("refresh.")
  ? refreshTranslations[lang]?.[path.slice(8)]
  : path.startsWith("formPlus.") ? formTranslations[lang]?.[path.slice(9)]
  : path.split(".").reduce((acc, key) => (acc == null ? undefined : acc[key]), translations[lang]);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => { try { const saved = localStorage.getItem("wb_lang"); return translations[saved] ? saved : "en"; } catch { return "en"; } });

  useEffect(() => {
    try { localStorage.setItem("wb_lang", lang); } catch { /* Persistence is optional. */ }
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const t = (path, params = {}) => {
    let value = lookup(lang, path);
    if (value === undefined) value = lookup("en", path);
    if (typeof value === "string") {
      Object.entries(params).forEach(([k, v]) => {
        value = value.replaceAll(`{${k}}`, String(v));
      });
    }
    return value;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
